import { Component, inject, signal, output, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductsService } from '../../services/product.service';

export interface CatalogTemplateItem {
  _id: string;
  name: string;
  description: string;
  merchantType: string;
  activityType: string;
  icon: string;
  tags: string[];
  productCount: number;
  topProducts: string[];
  popularity: number;
}

@Component({
  selector: 'app-catalog-template-picker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './catalog-template-picker.component.html',
})
export class CatalogTemplatePickerComponent {
  private productsService = inject(ProductsService);

  /** Optional filters from parent */
  merchantType = input<string | undefined>(undefined);
  activityType = input<string | undefined>(undefined);
  isOnboarding = input<boolean>(false);

  /** Emitted when template is applied */
  templateApplied = output<{ templateName: string; productsCreated: number }>();
  close = output<void>();

  templates = signal<CatalogTemplateItem[]>([]);
  selectedTemplate = signal<any | null>(null);
  loading = signal(false);
  applying = signal(false);
  applyMode = signal<'merge' | 'replace'>('merge');
  error = signal<string | null>(null);

  ngOnInit() {
    this.loadTemplates();
  }

  loadTemplates() {
    this.loading.set(true);
    this.productsService
      .getTemplates({
        merchantType: this.merchantType(),
        activityType: this.activityType(),
      })
      .subscribe({
        next: (res: any) => {
          this.templates.set(res.data || []);
          this.loading.set(false);
        },
        error: () => {
          this.error.set('Impossible de charger les templates');
          this.loading.set(false);
        },
      });
  }

  selectTemplate(t: CatalogTemplateItem) {
    this.loading.set(true);
    this.productsService.getTemplateDetail(t._id).subscribe({
      next: (res: any) => {
        this.selectedTemplate.set(res.data);
        this.loading.set(false);
      },
      error: () => {
        this.error.set('Erreur chargement template');
        this.loading.set(false);
      },
    });
  }

  backToList() {
    this.selectedTemplate.set(null);
  }

  apply() {
    const tmpl = this.selectedTemplate();
    if (!tmpl) return;
    this.applying.set(true);
    const mode = this.isOnboarding() ? 'merge' : this.applyMode();
    this.productsService.applyTemplate(tmpl._id, mode).subscribe({
      next: (res: any) => {
        this.applying.set(false);
        this.templateApplied.emit({
          templateName: res.data.templateName,
          productsCreated: res.data.productsCreated,
        });
        this.selectedTemplate.set(null);
      },
      error: (err) => {
        this.applying.set(false);
        console.error('applyTemplate error:', err);
        this.error.set(
          err?.error?.message || "Erreur lors de l'application du template",
        );
      },
    });
  }
}
